import {EventSpec} from '@mintdata/mint-kit/api/events/EventSpec';
import {EventPropName} from '@mintdata/mint-kit/api/events/EventType';

export class EventMap
{
    private _events:Array<EventSpec> = [];
    private _propNameToEvent:any = {};
    private _eventPropNames:Array<EventPropName> = [];

    public add(event:EventSpec):void
    {
        this._events.push(event);
        const name = event.eventPropertyName;

        this._propNameToEvent[name] = event;
        this._eventPropNames.push(name);
    }

    public findByPropName(propName:EventPropName):EventSpec
    {
        let event:EventSpec = this._propNameToEvent[propName];
        return event || null;
    }

    public getEvents():Array<EventSpec>
    {
        return this._events;
    }

    public getEventPropNames():Array<EventPropName>
    {
        return this._eventPropNames;
    }
}
